import ApiClient from '../apiClient'
import { getUserId } from '../user'

const client = new ApiClient()

const getBackgroundCheck = ({ userId = getUserId() }) => {
  return client.get(`/users/${userId}/background-check`)
}

const getBackgroundCheckV2 = ({
  userId = getUserId(),
  active = 1,
  executive = 1,
}) => {
  return client.get(`/users/${userId}/background-check-v2`, {
    params: { active, executive },
  })
}

const franceBankService = {
  getBackgroundCheck,
  getBackgroundCheckV2,
}

export default franceBankService
